import tracker from './Tracker';
import {
  extractTrackParamsFromElement,
  findTrackElement,
  shouldIgnoreTrackElement,
} from './utils';

let boundHandler = null;

/**
 * 启动全局点击委托监听
 */
export function startClickListener() {
  if (boundHandler) {
    return;
  }

  boundHandler = (event) => {
    const targetEl = findTrackElement(event.target);
    if (!targetEl || shouldIgnoreTrackElement(targetEl)) {
      return;
    }

    const eventName = targetEl.getAttribute('data-track') || '';
    if (!eventName) {
      return;
    }

    const extra = extractTrackParamsFromElement(targetEl);
    tracker.trackClick(eventName, extra);
  };

  document.addEventListener('click', boundHandler, true);
}

/**
 * 停止全局点击委托监听
 */
export function stopClickListener() {
  if (!boundHandler) {
    return;
  }

  document.removeEventListener('click', boundHandler, true);
  boundHandler = null;
}
